<template>
  <div v-loading="showLoading" class="relative" ref="el_alert_box_ref">
    <!-- 用于显示错误提示，滚动到指定位置 -->
    <input ref="focusRef" type="text" class="absolute top-[0] left-[0] w-[0] h-[0]" />
    <transition name="el-zoom-in-top">
      <div class="mb-[10] duration-300" v-show="tips_.msg">
        <el-alert @close="handleClose" v-show="tips_.msg" :title="tips_.msg" :type="tips_.type" show-icon> </el-alert>
      </div>
    </transition>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "dg-alert-box",
  props: {
    // 是否显示loading
    loading: {
      type: Boolean,
      default: true,
    },
    // 是否 tips
    tips: {
      type: Boolean,
      default: true,
    },
    urls: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      showLoading: false,
      dgFormDialogOpen: false,
      tips_: {
        msg: "",
        type: "error",
      },
    };
  },
  methods: {
    /**
     * @author 伟健 / 张
     * @name 清除提示
     */
    handleClose() {
      this.tips_.msg = "";
      this.tips_.type = "error";
    },
    /**
     * @author 伟健 / 张
     * @name 根据必填项内容，判断是否显示提示框
     */
    checkTips(msg) {
      if (msg.indexOf('请') > -1 || msg.indexOf('复制') > -1) return true;
      let innerText = null;
      if (this.$refs.el_alert_box_ref) {
        innerText = this.$refs.el_alert_box_ref.innerText;
      }
      let r = this.getContentBetweenAsteriskAndNewline(innerText || '')
      this.innertext = this.innertext.concat(r)
      return this.innertext.some(item => msg.indexOf(item) > -1)
    },
    /**
   * 获取 * 和换行符之间的内容
   * @param {string} text - 输入的文本
   * @param {boolean} includeAsterisk - 是否包含开头的*号，默认为false
   * @returns {string[]} 匹配到的内容数组
   */
    getContentBetweenAsteriskAndNewline(text, includeAsterisk = false) {
      // 正则解释：
      // \* - 匹配*号
      // (.*?) - 非贪婪匹配任意字符（除了换行符）
      // \n - 匹配换行符
      const regex = /\*(.*?)\n/g;
      const matches = [];
      let match;
      while ((match = regex.exec(text)) !== null) {
        // match[1] 是第一个捕获组的内容（.*?匹配的部分）
        if (includeAsterisk) {
          matches.push('*' + match[1].replace(/\s|\:|\：/g, ''));
        } else {
          matches.push(match[1].replace(/\s|\:|\：/g, ''));
        }
      }
      return matches;
    },

    showTips(msg) {
      let time = null;
      if (typeof msg == "string") {
        this.tips_.msg = msg;
        this.tips_.type = "warning";
      } else if (msg) {
        if (msg.type == "success") {
          clearInterval(time);
          time = setTimeout(() => {
            this.tips_.msg = "";
          }, 3000);
        }
        this.tips_.msg = msg.msg || msg.message;
        this.tips_.type = msg.type || 'warning';
      }
      this.$nextTick(() => {
        this.$refs.focusRef && this.$refs.focusRef.focus();
      });
    },

  },
  mounted() {
    let classList = ['el-form-item__label']
    this.$nextTick(() => {
      let innerText = [];
      classList.forEach(item => {
        let els = this.$refs.el_alert_box_ref.getElementsByClassName(item);
        for (let i = 0; i < els.length; i++) {
          let el = els[i];
          if (window.getComputedStyle(el, '::before').content == '"*"') {
            innerText.push(el.innerText.replace(/\s|\:|\：/g, ''))
          }
        }
      })
      this.innertext = innerText;
    });
  },
  created() {

    Mirror.watch("tips_el_alert_box_close", () => {
      this.handleClose();
    });
    // 监听弹窗打开 dg-form-dialog 如： 修改发票，防止多个loding 显示
    Mirror.watch("dg_form_dialog_open", () => {
      this.dgFormDialogOpen = true;
    });
    // 监听弹窗关闭 dg-form-dialog
    Mirror.watch("dg_form_dialog_close", () => {
      console.log('dg_form_dialog_close');
      this.dgFormDialogOpen = false;
    });

    Mirror.watch(["tips_el_alert_box_open"], (key, msg, url = "") => { 
      if (this.urls.length > 0 && !this.urls.includes(url) && url) return; // 监听指定的URL ，不传则全部
      if (this.dgFormDialogOpen || !this.tips) return;
      if (msg.serverError) {
        this.showTips(msg)
        return;
      }; 
      if (!this.checkTips(msg.message || msg.msg || msg)) return;
      this.showTips(msg)
    });

    let loading = [];
    Mirror.watch("loading_el_alert_box_open", (key, url) => {
      if (this.urls.length > 0 && !this.urls.includes(url)) return; // 监听指定的URL ，不传则全部
      if (this.dgFormDialogOpen || !this.loading) return;

      this.showLoading = true;
      loading.push(1);
    });
    Mirror.watch("loading_el_alert_box_close", () => {
      loading.pop();
      if (!loading.length) {
        this.showLoading = false;
      }
    });
  },
};
</script>
<style scoped></style>
